import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// components
import Sidebar from "components/Sidebar/Sidebar.js";
import CardFullTable from "components/Cards/Admin/CardFullTable.js";
// texts as props
import sidebar from "_texts/admin/sidebar/sidebar.js";
import { useDispatch, useSelector } from "react-redux";
import { getFunctions } from "actions/workflows";
import NiceModal from "@ebay/nice-modal-react";

const Functions = ({ navigation }) => {
  const location = useLocation();
  const functions = useSelector((state) => state.workflows.functions);
  const dispatch = useDispatch();
  const [body, setBody] = useState([]);
  const [head, setHead] = useState([]);
  const [retrievedFunctions, setRetrievedFunctions] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (functions.length === 0 && !retrievedFunctions) {
      setRetrievedFunctions(true);
      dispatch(getFunctions());
    } else {
      const keys = ["id", "public_id", "name", "description", "actions"];
      setHead(keys);
      setBody(
        functions.map((funct) => {
          const values = [
            funct.id,
            funct.public_id,
            funct.name,
            funct.description ?? "",
            <></>,
          ];
          return values;
        })
      );
    }
  }, [functions, retrievedFunctions, dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const editFunction = (row) => {
    const funct = {};
    head.forEach((key, index) => {
      funct[key] = row[index];
    });
    //NiceModal.show('add-function', {function: function});
    navigate(`/admin/function/${funct.public_id}`);
  };

  return (
    <>
      <Sidebar {...sidebar} />
      <div
        className="relative md:ml-64 bg-blueGray-100 pt-24"
        style={{ height: "100%", minHeight: "100vh" }}
      >
        <div className="px-4 md:px-6 mx-auto w-full -mt-24 pt-24">
          <div className="flex flex-wrap">
            <div className="w-full px-4">
              <CardFullTable
                title="Functions"
                titlebutton={
                  <i
                    onClick={() => NiceModal.show("add-function")}
                    className="fa fa-plus text-sm cursor-pointer"
                  />
                }
                head={head}
                body={body}
                color="white"
                onRowClick={(row) => editFunction(row)}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Functions;
